export const PAGE_TITLE = "IIH Community Support Groups";

export const PAGE_TEXT =
  "A weekly opportunity to connect, share, and grow with your fellow students and graduates.";

export const PARAGRAPH_1 =
  "Step into a supportive space where your growth as a hypnotherapist is nurtured, your questions are welcomed, and your ideas are celebrated. Connect with fellow students and graduates, practice your skills, and receive encouragement from people who understand your journey.";

export const PARAGRAPH_2 =
  "Visit the IIH Community Support Groups page for the latest schedule, Zoom links, and details.";

export const SCHEDULE_CONFIG = {
  firstThird: {
    url: "https://us02web.zoom.us/j/84082264276",
    timeLabel: "4:00 PM ET",
  },
  secondFourth: {
    url: "https://us02web.zoom.us/j/83141853713",
    timeLabel: "7:30 PM ET",
  },
  exceptionDates: ["2026-01-21", "2026-01-28"],
};

export const SCHEDULE_PAGE_URL =
  "https://instituteofhypnotherapy.com/iih-community-support-groups/";

export const IMAGE = {
  src: "community_support.png",
  alt: "Community Support Groups",
};

export const NEXT_MEETING_LABEL = "Next Meeting";

export const BUTTON_JOIN_MEETING = "Join Meeting";

export const BUTTON_VIEW_SCHEDULE = "View Schedule & Join Support Groups";
